"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var selectors_1 = require("../../selectors");
var SaaSOverspendPopup_1 = __importDefault(require("../SavingOpportunityGraph/SaaSOverspendPopup"));
var styles_1 = require("./styles");
var SaasOverspend = function (_a) {
    var e_1, _b;
    var analysedToolsCount = _a.analysedToolsCount, totalToolsCount = _a.totalToolsCount;
    var audit = (0, react_redux_1.useSelector)(selectors_1.selectLatestAudit);
    // ToDo: use some AuditContext;
    if (!audit) {
        return null;
    }
    var analysedTools = audit.stackHealth.analysedTools;
    var countOfSpendType = {
        optimalPrice: 0,
        overspending: 0,
        notEnoughData: 0,
    };
    try {
        for (var _c = __values(Object.values(analysedTools)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var value = _d.value;
            countOfSpendType[value.overspendType] += 1;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ py: 2 }, { children: [(0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3 }, { children: ["SaaS Overspend", (0, jsx_runtime_1.jsx)(SaaSOverspendPopup_1.default, {})] })), (0, jsx_runtime_1.jsxs)(material_1.Table, __assign({ size: "small", sx: { mt: 2.5 } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.TableRow, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledTableCell, __assign({ width: 195 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "\uD83D\uDD18 Analysed Tools" })) })), (0, jsx_runtime_1.jsx)(styles_1.StyledTableCell, { children: (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [" ", (0, jsx_runtime_1.jsx)("strong", { children: analysedToolsCount })] })) })] }), (0, jsx_runtime_1.jsxs)(material_1.TableRow, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledTableCell, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "\uD83D\uDFE2 Optimal price" })) }), (0, jsx_runtime_1.jsx)(styles_1.StyledTableCell, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (0, jsx_runtime_1.jsx)("strong", { children: countOfSpendType.optimalPrice }) })) })] }), (0, jsx_runtime_1.jsxs)(material_1.TableRow, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledTableCell, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "\uD83D\uDD34 Overspending" })) }), (0, jsx_runtime_1.jsx)(styles_1.StyledTableCell, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (0, jsx_runtime_1.jsx)("strong", { children: countOfSpendType.overspending }) })) })] }), (0, jsx_runtime_1.jsxs)(material_1.TableRow, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledTableCell, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "\u26AA Not enough data" })) }), (0, jsx_runtime_1.jsx)(styles_1.StyledTableCell, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (0, jsx_runtime_1.jsx)("strong", { children: countOfSpendType.notEnoughData }) })) })] }), (0, jsx_runtime_1.jsxs)(material_1.TableRow, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledTableCell, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Total tools" })) }), (0, jsx_runtime_1.jsx)(styles_1.StyledTableCell, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (0, jsx_runtime_1.jsx)("strong", { children: totalToolsCount }) })) })] })] }))] })));
};
exports.default = SaasOverspend;
